import { Outlet } from 'react-router-dom';

import { BuildingInspectionContextProvider } from '@/pages/Tools/BuildingInspection/BuildingInspectionContext';

export const BuildingLayout = () => {
  return (
    <BuildingInspectionContextProvider>
      <Outlet />
    </BuildingInspectionContextProvider>
  );
};
